import { PARTNERS } from '@/mocks/home';

export default function Partners() {
  const items = [...PARTNERS, ...PARTNERS];
  return (
    <section className="border-y border-background-200 bg-background-100 py-10">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-foreground-500">
          Proud Members &amp; Accreditations
        </p>
      </div>
      <div className="mt-6 overflow-hidden">
        <div className="animate-marquee flex w-max items-center gap-4">
          {items.map((name, i) => (
            <span
              key={`${name}-${i}`}
              className="flex h-16 min-w-[160px] items-center justify-center rounded-lg border border-background-200 bg-background-50 px-8 font-heading text-lg font-bold tracking-tight text-secondary-800"
            >
              {name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}